import {CRUD_CREATE_FAILURE} from "admin-on-rest";
import {stopSubmit} from 'redux-form';
import {put, takeEvery} from "redux-saga/effects";
import {messages} from "../AppMessages";

export default function* errorSagas() {
  yield takeEvery(CRUD_CREATE_FAILURE, crudCreateFailure);
}

export function* crudCreateFailure(action) {
  if (action.error && action.error.payload && action.error.payload.errors) {
    var errors = action.error.payload.errors;
    // json structure looks like this:
    // {
    //     username: "This username is already taken",
    //     age: "Your age must be above 18 years old"
    // }
    let json = {};
    errors.forEach(error => {
      let att = error.source.pointer.replace('/data/attributes/','');
      let translated = messages['sv']['errors'][error.code];//todo remove sv
      json[att] = translated;
    });
    yield put(stopSubmit('record-form', json));
  } else {
    console.log('EXIT');
  }
  
}


// WEBPACK FOOTER //
// ./src/sagas/errorSagas.js